module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/th-card-drag.7aa5831fa77d5494dc68.gif";